import {
  CustomPlaceholderValue,
  DashboardTypes,
  GetCustomValueHistoryQuery,
  SaveCustomValueMutation,
  SaveCustomValueMutationVariables,
} from 'API';
import { API } from 'aws-amplify';
import { saveCustomValue } from 'graphql/mutations';
import { getCustomValueHistory } from 'graphql/queries';
import { KPIvalues } from '../CustomReportKPI';
import { useCustomReportContext } from 'context/CustomReportContext';

export const useGetKPIValues = (): readonly [(position: string) => Promise<CustomPlaceholderValue[] | null>] => {
  const { activeCustomReport } = useCustomReportContext();
  const fetchCustomReportKPI = async (position: string) => {
    try {
      const response = (await API.graphql({
        query: getCustomValueHistory,
        variables: {
          campaignId: activeCustomReport?.CustomReportID,
          dashboardType: 'OVERALL',
          position: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetCustomValueHistoryQuery };
      const { data } = response;
      const list = data.getCustomValueHistory as any[];
      return list;
    } catch (e) {
      console.error(e);
      return null;
    }
  };
  return [fetchCustomReportKPI];
};

export const useSaveCustomReportKPI = (): readonly [
  (position: string, obj: KPIvalues, customReportId?: number) => Promise<string>,
] => {
  const { activeCustomReport } = useCustomReportContext();
  const saveCustomReportKPI = async (position: string, obj: KPIvalues, customReportId?: number) => {
    const idToUse = customReportId || activeCustomReport?.CustomReportID;
    console.log('USE SAVE CUSTOM REPORT KPI', obj);
    try {
      const response = (await API.graphql({
        query: saveCustomValue,
        variables: {
          CustomValue: {
            campaignId: idToUse,
            dashboardType: 'OVERALL',
            position: position,
            floatValue: obj.value,
            label: obj.labelTitle === '' ? 'Custom value' : obj.labelTitle,
            subtitle: obj.labelSubtitle === '' ? 'Custom value' : obj.labelSubtitle,
            format: obj.valueFormat === '' ? 'number' : obj.valueFormat,
          },
        } as SaveCustomValueMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: SaveCustomValueMutation };
      const r = response.data.saveCustomValue;
      if (r) {
        if (r.status === '200') {
          return 'success';
        } else {
          return r.message as string;
        }
      } else {
        return 'error';
      }
    } catch (e) {
      console.log('ERROR SAVING CUSTOM REPORT KPI', e);
      return 'ERROR SAVING CUSTOM REPORT KPI';
    }
  };
  return [saveCustomReportKPI];
};
